export default __webpack_public_path__ + "images/dashBoardUserIcon.1ea833ec.svg";